import { AnnouncementBanner } from "~landing/components/home/announcement-banner";
import { bannerConfig } from "~landing/components/home/banner-config";
import { Benefits } from "~landing/components/home/benefits";
import { Faqs } from "~landing/components/home/faqs";
import { FeatureHighlights } from "~landing/components/home/feature-highlights";
import { Hero } from "~landing/components/home/hero";
import { HowItWorks } from "~landing/components/home/how-it-works";
import { PricingTeaser } from "~landing/components/home/pricing-teaser";
import { StartBuilding } from "~landing/components/home/start-building";
import { Testimonials } from "~landing/components/home/testimonials";
import { UseCases } from "~landing/components/home/use-cases";
import { gisContent } from "~landing/components/gis/content";
import { MarketingPage } from "~landing/components/layout/marketing-page";

export function HomeView() {
	return (
		<MarketingPage topBanner={<AnnouncementBanner config={bannerConfig} />}>
			<Hero content={gisContent.hero} />
			<Benefits content={gisContent.benefits} />
			<UseCases content={gisContent.useCases} />
			<Testimonials content={gisContent.testimonials} />
			<HowItWorks content={gisContent.howItWorks} />
			<Faqs content={gisContent.faqs} />
			<FeatureHighlights content={gisContent.featureHighlights} />
			<PricingTeaser content={gisContent.pricingTeaser} />
			<StartBuilding content={gisContent.startBuilding} />
		</MarketingPage>
	);
}
